var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00051 5.88317C9.81791 5.88317 11.2912 7.35647 11.2912 9.17388C11.2912 10.9913 9.81791 12.4646 8.00051 12.4646C6.1831 12.4646 4.7098 10.9913 4.7098 9.17388C4.7098 7.35647 6.1831 5.88317 8.00051 5.88317ZM8.00051 3C11.7959 3 15.0723 5.59144 15.9814 9.22304C16.0641 9.55361 15.8632 9.88866 15.5327 9.97141C15.2021 10.0542 14.8671 9.85327 14.7843 9.5227C14.0119 6.43711 11.2265 4.23401 8.00051 4.23401C4.77309 4.23401 1.98682 6.43901 1.21578 9.52642C1.13321 9.85703 0.798264 10.0581 0.467654 9.97554C0.137045 9.89297 -0.0640347 9.55803 0.0185313 9.22742C0.926019 5.59367 4.20343 3 8.00051 3Z",
    fill: "#B9BBBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShow);
export default __webpack_public_path__ + "static/media/ic-show.287662247c94511c136ee24605434a46.svg";
export { ForwardRef as ReactComponent };